const accessInventory = {

    INWARD_LIST: { name: 'Inward', path: '/inward-list' },
    ADD_INWARD: { name: 'Add Inward', path: '/create-inward' },
    STOCK_AVAILABILITY_LIST: { name: 'Stock Availability', path: '/stock-availability-list' },
    PRICING_LIST: { name: 'Pricing', path: '/pricing-list' },
    ADD_PRICING: { name: 'Add Pricing', path: '/create-pricing' },
    OUTWARD_LIST: { name: 'Outward', path: '/outward-list' },

}

export default accessInventory;